import { GetStaticProps } from "next";
import React, { useEffect } from "react";
import { MetaTagsComp } from "../../components/MetaTagsComp";
import ScholarshipPage from "../../components/ScholarshipsPage/ScholarshipPage";
import fetchUtil from "../../utils/fetchUtil";

const Scholarships: React.FC = (props: any) => {
  const { meta } = props.pageData;
  useEffect(() => {
    const customStyle = document.documentElement.style;
    customStyle.setProperty("--navbar-color", "#226CF5");
    customStyle.setProperty("--navbar-menu-color", "#ffff");
  }, []);
  return (
    <>
      {meta && <MetaTagsComp {...meta} />}
      <ScholarshipPage {...props} />
    </>
  );
};

export const getStaticProps: GetStaticProps = async (context) => {
  const pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/scholarships`, "GET", {}, "", false);
  const countrySpecificScholarshipsData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/new-country-specific-scholarships`, "GET", {}, "", false);
  return {
    props: { pageData, countrySpecificScholarshipsData },
  };
};

export default Scholarships;
